import React from 'react'
import './Plans.css'
import {plansData} from '../../data/plansData'
import whiteTick from '../../assets/whiteTick.png'
import { Link } from 'react-scroll'

function Plans() {
  return (
    <div className="plans-container" id='plans'>

        <div className="blur blur-plan-1"></div>
        <div className="blur blur-plan-2"></div>

        <div className="programs-header" style={{gap:'2rem'}}>
            <span className='stroke-text'>Ready to start</span>
            <span> Your journy</span>
            <span className='stroke-text'> with us</span>
        </div>

        <div className="plans">
            {plansData.map((plan, i)=>(

                <div className="plan" key={i}>

                    {plan.icon}
                    <span>{plan.name}</span>
                    <span>$ {plan.price}</span>

                    <div className="features">
                        {plan.features.map((feature, i)=>(
                            <div className="feature">
                                <img src={whiteTick} alt="" />
                                <span key={i}>{feature}</span>
                            </div>
                        ))}
                    </div>
                    <div>
                        <span>See more benifits -{`>`}</span>
                    </div>
                    <button className="btn">
                    <Link
                    to='join'
                    span={true}
                    smooth={true}>Join Now</Link>
                    </button>
                </div>
            ))}
        </div>
    </div>
  )
}

export default Plans